import React, { useMemo, useState } from "react";
import { useData } from "../../context/DataContext";
import { extractEmployees, cellText } from "../../utils/helpers";

export default function UsersPage() {
  const { adminRecords, loading } = useData();
  const [search, setSearch] = useState("");

  const employees = useMemo(() => {
    const emps = extractEmployees(adminRecords);
    return emps.map(emp => {
      const tasks = adminRecords.filter(r => {
        const u = r.fields?.["Assigned Users"];
        if (!u) return false;
        const arr = Array.isArray(u) ? u : [u];
        return arr.some(x => (x?.en_name || x?.name || x || "").toLowerCase().includes(emp.name.toLowerCase()));
      });
      const statuses = tasks.map(r => cellText(r.fields?.["Overall Status"]).toLowerCase());
      return {
        ...emp, total: tasks.length,
        done: statuses.filter(s => s.includes("done")).length,
        overdue: statuses.filter(s => s.includes("overdue")).length,
        inProgress: statuses.filter(s => s.includes("progress")).length,
        notStarted: statuses.filter(s => s.includes("not started") || s.includes("⬜")).length,
      };
    });
  }, [adminRecords]);

  const filtered = employees.filter(e =>
    !search || e.name.toLowerCase().includes(search.toLowerCase())
  );

  if (loading && adminRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading...</span></div>;

  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>👥 Employees</h1>
        <p>{employees.length} team members in the system</p>
      </div>

      <div className="toolbar" style={{ marginBottom: 20 }}>
        <div className="search-wrapper" style={{ flex: 1 }}>
          <span className="search-icon">🔍</span>
          <input className="search-input" style={{ width: "100%" }} placeholder="Search employees..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
      </div>

      <div className="employee-grid">
        {filtered.map(emp => (
          <div key={emp.name} className="employee-card">
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
              <div className="avatar avatar-employee avatar-lg">
                {emp.name.split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2)}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, color: "var(--gray-900)", fontSize: 15 }}>{emp.name}</div>
                <div style={{ fontSize: 12, color: "var(--gray-400)", marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {emp.email || "No email on record"}
                </div>
                <div style={{ marginTop: 6 }}>
                  <span className="badge badge-info" style={{ fontSize: 10 }}>
                    {emp.total} task{emp.total !== 1 ? "s" : ""}
                  </span>
                </div>
              </div>
            </div>
            <div className="employee-mini-stats">
              {[
                { label: "Done", value: emp.done, color: "var(--success)" },
                { label: "Progress", value: emp.inProgress, color: "var(--warning)" },
                { label: "Overdue", value: emp.overdue, color: "var(--danger)" },
                { label: "Pending", value: emp.notStarted, color: "var(--gray-500)" },
              ].map(s => (
                <div key={s.label} className="employee-mini-stat">
                  <div className="employee-mini-stat-label">{s.label}</div>
                  <div className="employee-mini-stat-value" style={{ color: s.value === 0 ? "var(--gray-300)" : s.color }}>{s.value}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
